<template>
  <div class="hello">
    <h1>{{ msg }}</h1>    
      <br/>




      <div v-if="ready" class="courseList">
        <div class="courseListRow">
          <div class="courseListCell">Course Name</div>
          <div class="courseListCell">Open course</div>
          <div class="courseListCell">Completion</div>
        </div>

        <div v-for="c in courselist" :key="c.id" class="courseListRow" >
            <div class="courseListCell">
              Course {{ c.courseTitle }} is completed {{  c.isCompleted }}
            </div>
            <div class="courseListCell">
              <div class="button-wrapper">
                <button @click="openIframe(c.courseIdentifier)" class="button-19" role="button">Open</button>
              </div>
            </div>
            <div class="courseListCell">
              <div class="checkbox-wrapper-22">
                <label class="switch" for="checkbox">
                  <input type="checkbox" id="checkbox" :checked=c.isCompleted disabled />
                  <div class="slider round"></div>
                </label>
              </div>
            </div>
        </div>
      </div>
      <div v-else>
        Loading
      </div>
      <!--
      <div class="button-wrapper">
        <button @click="openIframe" class="button-19" role="button">Open course</button>
      </div>
      -->
  </div>
</template>

<script>

//Scorm Cloud IFRAME
//https://cloud.scorm.com/ScormEngineInterface/defaultui/player/modern.html?configuration=ji1uT03wBtlosOMgLLuE8zoKAAwQ-zD1qqJaHnUOB24XkIYcLDUvFkc6RPaNWSE3cA_yYd6FpJLDS1n0DoiVVhXZ7KsyDtCrOlKPrEvDTpAHpSclGiRKa9HE_ISmbiF2b9IA60u9YtwFKvXw0fBbd0eaVHNMPuGjrUclZS-YSSKXelV7FDNzg9U4O03urJW9RSyJL-pwbEkI5ALq5NchjWNuQ812Ys7Rl775Tv2kgD6diU2KbgC-5MnFLzCzK6Epa-efBGi4gh8gfv2SP6VV5zBzpfwNh2mAn73GffFHhQ4Q_SmCEw6694nXKRnP28RABzTLx00_72_JoHFiLtBg9UeBFJP7zFk8Bv2_gWKVgzCBlYqP4Gi0wOad2F16HJ-NH8P3nyxO5jyQwY6QHIulMU-_lsn8jGgAeqtHhdZWMuJRkfj5rCZcWPpBgrwTA1qcypUQXqgX8HTPFwkSzv_Ch8IWPLxdqrWbmGr9ewl1PcnN8P7caOU6D_9XFbbyqZVsFUko2fXAY-5b7U-d04twpVsVolO02N7SQ2yyMJig94XTH8LD9i2SGX2Rz6qLf2ohvrkZrng1dnEikgrZctmTcpd2GSuNX_o4nUx5frpgrvgXig5AJVTRC2tfhUwGAN9bZJF9gck0XaKXpJ7OGT3LKidbHxAo6j2s4u6if4f5i38YP0KBhJYv3ZrQgCJeWheUGTZ_WCl5Z_gU7kE7jkMjSYGPuNW6zcbkNQWQkx00bEKWmxd0a_xG7aUh_WVfpXe_KGKRsr6u-YeRTWxfDiOSu_SRzr2-GjGVKmvu3eqpDSztYat0j-ALeOKM7BMPtxAGdOuG5Dlf8C7oI9_rb0zTbBuLL-iIgcHHn4STcRvAwpqn4Hf2KuzUPLIE5xIxKaMFfCpxuSWcI-it2QhjuxbukVkkvvb9cP-9cuAkuq-nbWVG3GjCSxj46ISq-4hTwpAmNenk2q7iawKl9I0MUCV8e2I6anYoGAWMI-vxzjIL_Mw_Ale-TLJaHqX-aBp3_69pViqE7qvKZK16c4e06-tfqQKoT00&preventRightClick=false&cc=en_GB&cache=21.1.35.500&playerConfUrl=j&package=hK1H5jClTZTQlV8k_LNA7j5vFDLyL8lF9lCt_Y4gSD8AQGq61gDVREo2mUXrqFBHnG6bMFwwZCJcfX1CuUvVTra0d-xTKKKT-4CMhl2GPBpaZa4ppx1DDevR6hJyPIoHeXD9Dw0bdT6xF9Wme5cmuZ2LVtw&redirectUrl=https%3A%2F%2Fapp.cloud.scorm.com%2Fsc%2Fuser%2FPostLaunch%3FappId%3D3CV2259611%26realmId%3Ddc8e48d2-cd67-4ec9-891c-65e6a7427272%26registrationId%3D9bc4a201-e3cc-4bd3-b50e-7c0664add8f0%26redirectUrl%3Dhttps%253A%252F%252Fapp.cloud.scorm.com%252Fsc%252Fuser%252FCourse%253FappId%253D3CV2259611%2526courseId%253Dv57-2004_manifest_scormcloud65181aec-0b4f-4ad2-abc2-c07931f9b7bf&registration=Sjt7xC-XgzegraeNkTpPW6tvqamHJP8qvhevY4ZLW_UFgpxUWzEgiJJJAiArno3_Mqe_sfBDckjtplKtMtIN7O1y0KfVuFjzzj4IFR1bFlpqfvnB5Hi-Xy2mbFYfACM&tracking=true&forceReview=false&player=modern&ts=20241115145432

export default {
  data() {
    return {
        ready: false,
        email: "kdj@cadpeople.dk",
        lmsemail: "1E-B0-A6-00-78-99-E8-DA-4A-C5-22-93-60-DD-5C-29-D9-98-BB-E8@virtual-campus.lms.ca",
        courselist : [
          {
            courseIdentifier : "2b1da408-9b7f-430f-a163-658f2dac0186",
            courseLRSIdentifier : "https://lms.cadpeople.dk/virtual_campus_lms/demo_course/introduction_to_elearning",
            courseTitle: "Demo course",
            isCompleted : false
          },
          {
            courseIdentifier : "http://XRbt5FnbVepIFg8loraLZnxfqlrdRohy_rise",
            courseLRSIdentifier : "http://XRbt5FnbVepIFg8loraLZnxfqlrdRohy_rise",
            courseTitle: "External course",
            isCompleted : false
          }
      ]
    }
  },
  name: 'HelloWorld',
  props: {
    msg: String
  },
  mounted() {
    this.fetchStatus();
  },
  methods: {
    openIframe(courseId) {
      const iframe = document.createElement('iframe');
      iframe.setAttribute("class","learning-iframe");
      
      var url = this.getIframeLink(courseId);
      iframe.src = url;
      //iframe.src = "https://virtual-campus-lms-avdfffgufvb9hkaa.northeurope-01.azurewebsites.net/media/ihgheekh/index.html?email=kdj@cadpeople.dk";
      document.body.appendChild(iframe);

      const iframeclosebutton = document.createElement('button');
      iframeclosebutton.setAttribute("role", "button")
      iframeclosebutton.setAttribute("class", "button-19");
      iframeclosebutton.setAttribute("class", "iframe-close-button");
      iframeclosebutton.textContent  = "X"
      iframeclosebutton.onclick = this.closeIframe;
      document.body.appendChild(iframeclosebutton);
    },

    closeIframe(){
      var theIframe = document.getElementsByClassName('learning-iframe');      
      document.body.removeChild(theIframe[0]);
      var thebutton = document.getElementsByClassName('iframe-close-button');
      document.body.removeChild(thebutton[0]);

      this.fetchStatus();
    },

    getIframeLink(courseId){      
      var url = "https://virtual-campus-lms.cadpeople.dk/umbraco/api/course/LoadModule" ;//?moduleKey=2b1da408-9b7f-430f-a163-658f2dac0186&email=doro@cadpeople.dk";
      url += "?moduleKey=" + courseId;
      url += "&email=" + this.email;

      return url;
    },

    fetchStatus(){

      console.log("Fetching status");
      var result = "";

      fetch("https://virtual-campus-lms-api.cadpeople.dk/UserProgress?userId=" + this.lmsemail, {      
        crossdomain: true        
      }).then(resp => resp.json())
        .then(json => {
          result = json;            
          
          console.log(result);
          this.courselist.forEach((course) => {                      
            var p = result.find(i => i.courseIndetifier == course.courseLRSIdentifier);          
            if (p != null){          
              course.isCompleted = true;
            }
          });

          this.ready = true;
          //this.courselist = result;

          //this.$forceUpdate();
        });

    }
  }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.checkbox-wrapper-22 .switch {
  display: inline-block;
  height: 34px;
  position: relative;
  width: 60px;
}

.checkbox-wrapper-22 .switch input {
  display:none;
}

.checkbox-wrapper-22 .slider {
  background-color: #ccc;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: .4s;
}

.checkbox-wrapper-22 .slider:before {
  background-color: #fff;
  bottom: 4px;
  content: "";
  height: 26px;
  left: 4px;
  position: absolute;
  transition: .4s;
  width: 26px;
}

.checkbox-wrapper-22 input:checked + .slider {
  background-color: #66bb6a;
}

.checkbox-wrapper-22 input:checked + .slider:before {
  transform: translateX(26px);
}

.checkbox-wrapper-22 .slider.round {
  border-radius: 34px;
}

.checkbox-wrapper-22 .slider.round:before {
  border-radius: 50%;
}

.courseList {
  display: table;
}

.courseListRow {
  display: table-row;
}

.courseListCell {
  display: table-cell;
  padding: 3px 10px;
}

.button-wrapper {
  width: 200px;
  display: inline-block;
}

.iframe-close-button {
  position: absolute;
  left: 10px;
  top: 10px;
}

/* CSS */
.button-19 {  
  appearance: button;
  background-color: #1899D6;
  border: solid transparent;
  border-radius: 16px;
  border-width: 0 0 4px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: din-round,sans-serif;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: .8px;
  line-height: 20px;
  margin: 0;
  outline: none;
  overflow: visible;
  padding: 13px 16px;
  text-align: center;
  text-transform: uppercase;
  touch-action: manipulation;
  transform: translateZ(0);
  transition: filter .2s;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
}

.button-19:after {
  background-clip: padding-box;
  background-color: #1CB0F6;
  border: solid transparent;
  border-radius: 16px;
  border-width: 0 0 4px;
  bottom: -4px;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}

.button-19,
.button-19:focus {
  user-select: auto;
}

.button-19:hover:not(:disabled) {
  filter: brightness(1.1);
  -webkit-filter: brightness(1.1);
}

.button-19:disabled {
  cursor: auto;
}

.button-19:active {
  border-width: 4px 0 0;
  background: none;
}

.learning-iframe {
  position: fixed;
  width: 95vw;
  height: 95vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-style:none;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
